var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/settings/UpdatePassword/index.tsx";
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Button, IconClose, InformationalScreen } from '@adc/parallax-component-library';
import { ApiStatus, ErrorCode } from 'Constants';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAccount, useApiError, useAuth } from 'Hooks';
import { Banner, FormContainer, InputPassword, MainContainer, PasswordInputValidator } from 'Components/utility';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { updatePassword } from 'Services/patient';
const mapStateToProps = ({
  config: {
    passwordRules
  },
  auth,
  env: {
    deviceId,
    installationId,
    osType,
    osVersion,
    app,
    appVersion
  }
}) => {
  return {
    email: auth.include.patient.email,
    accountId: auth.account_id,
    deviceId,
    installationId,
    osType,
    osVersion,
    app,
    appVersion,
    country: auth.include.patient.country,
    passwordRules
  };
};
const initialValuesFormik = {
  currentPassword: '',
  newPassword: '',
  repeatNewPassword: ''
};
const connector = connect(mapStateToProps);
const UpdatePassword = ({
  email,
  accountId,
  osType,
  osVersion,
  app,
  appVersion,
  country,
  passwordRules
}) => {
  const [meetsPasswordRequirements, setMeetsPasswordRequirements] = useState(false);
  const [formRefreshFlag, setFormRefreshFlag] = useState(false);
  const handleClickBack = useCallback(() => {
    notifyApp('adc-webview:navigate-back-app');
  }, []);
  const {
    showPasswordValidationError
  } = useAccount();
  const {
    showApiErrorModal,
    showNetworkErrorModal
  } = useApiError();
  const {
    handleLoginError,
    handleLockoutError,
    showHcpError,
    isLocked,
    lockoutMessage,
    lockoutSubmessage
  } = useAuth('changepassword');
  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string().required(i18n.t('ChangePassword.content.changePasswordAccountInfoForm.formField.currentPassword.errors.required')).trim(),
    repeatNewPassword: Yup.string().oneOf([Yup.ref('newPassword')], i18n.t('ChangePassword.content.changePasswordAccountInfoForm.formField.repeatNewPassword.errors.passwordMustMatch')).required(i18n.t('ChangePassword.content.changePasswordAccountInfoForm.formField.currentPassword.errors.required'))
  });
  const handleClickForgotPass = () => {
    mediator.publish('router:navigate', '/forgot-password');
  };
  const {
    handleSubmit,
    handleBlur,
    handleChange,
    setFieldValue,
    setTouched,
    isValid,
    isSubmitting,
    errors,
    touched,
    values
  } = useFormik({
    initialValues: initialValuesFormik,
    onSubmit: onSubmitForm,
    validationSchema: validationSchema,
    validateOnBlur: true
  });
  const handleApiRequestError = useCallback((error, resetForm) => {
    switch (error.status) {
      case ApiStatus.FORBIDDEN:
        {
          var _error$response;
          const code = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.code;
          if (code === ApiStatus.FORBIDDEN_HCP_ACCOUNT) {
            showHcpError();
          }
          break;
        }
      case ApiStatus.UNAUTHORIZED:
        handleLoginError(error, () => {
          resetForm();
          setFormRefreshFlag(!formRefreshFlag);
        }, () => setFieldValue('currentPassword', ''));
        break;
      case ApiStatus.BAD_REQUEST:
        {
          var _error$response2, _error$response3;
          setFieldValue('newPassword', '');
          setFieldValue('repeatNewPassword', '');
          setTouched({});
          setFormRefreshFlag(!formRefreshFlag);
          const errors = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data.errors;
          const code = (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data.code;
          if (code === ApiStatus.INVALID_DATA_CODE) {
            showPasswordValidationError(passwordRules, errors, country);
            return;
          }
          showApiErrorModal();
          break;
        }
      case ApiStatus.TOO_MANY_REQUESTS:
        {
          handleLockoutError(error);
          resetForm();
          break;
        }
      default:
        error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
    }
  }, [handleLoginError, showNetworkErrorModal, showApiErrorModal, showHcpError, formRefreshFlag, setFieldValue, setTouched, showPasswordValidationError, passwordRules, country, handleLockoutError]);
  function onSubmitForm(data, {
    setSubmitting,
    resetForm
  }) {
    updatePassword({
      userID: accountId,
      emailConfirmation: email,
      newPassword: data.newPassword,
      currentPassword: data.currentPassword
    }, osType, osVersion, app, appVersion).then(() => {
      notifyApp('adc-webview:update-password');
    }).catch(error => {
      handleApiRequestError(error, resetForm);
    }).finally(() => {
      setSubmitting(false);
    });
  }
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen, {
    topNavigationProps: {
      title: i18n.t('ChangePassword.title'),
      buttonStart: {
        element: /*#__PURE__*/React.createElement(IconClose, {
          testID: "ChangePassword.back-button",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 236,
            columnNumber: 22
          }
        }),
        label: i18n.t('ChangePassword.title'),
        onPress: handleClickBack
      },
      testID: 'ChangePassword.title'
    },
    testID: "ChangePassword",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 232,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 244,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 245,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormContainer, {
    hasHiddenUserInput: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 246,
      columnNumber: 13
    }
  }, lockoutMessage ? /*#__PURE__*/React.createElement(Banner, {
    testID: "ChangePassword",
    message: lockoutMessage,
    submessage: lockoutSubmessage,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 248,
      columnNumber: 17
    }
  }) : null, /*#__PURE__*/React.createElement(InputPassword, {
    label: i18n.t('ChangePassword.content.changePasswordAccountInfoForm.formField.currentPassword.label'),
    placeholder: i18n.t('ChangePassword.content.changePasswordAccountInfoForm.formField.currentPassword.placeholder'),
    isInvalid: errors.currentPassword && touched.currentPassword ? true : false,
    errorMessage: errors.currentPassword,
    testID: "currentPassword",
    onChangeText: handleChange('currentPassword'),
    onBlur: handleBlur('currentPassword'),
    value: values.currentPassword,
    disabled: isLocked,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 254,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    label: i18n.t('ChangePassword.content.changePasswordAccountInfoForm.links.forgotPasswordLink.label'),
    onPress: handleClickForgotPass,
    testID: "ChangePassword.forgotPassword",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 269,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(PasswordInputValidator, {
    key: `new-password-validator-${formRefreshFlag}`,
    placeholder: i18n.t('ChangePassword.content.changePasswordAccountInfoForm.formField.newPassword.placeholder'),
    label: i18n.t('ChangePassword.content.changePasswordAccountInfoForm.formField.newPassword.label'),
    errors: errors,
    touched: touched,
    handleBlur: handleBlur('newPassword'),
    password: values.newPassword,
    onValidate: setMeetsPasswordRequirements,
    passwordRules: passwordRules,
    onChangeText: handleChange('newPassword'),
    testID: "newPassword",
    disabled: isLocked,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 277,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(InputPassword, {
    key: `new-password-check-${formRefreshFlag}`,
    mt: "$1",
    label: i18n.t('ChangePassword.content.changePasswordAccountInfoForm.formField.repeatNewPassword.label'),
    placeholder: i18n.t('ChangePassword.content.changePasswordAccountInfoForm.formField.repeatNewPassword.placeholder'),
    isInvalid: errors.repeatNewPassword && touched.repeatNewPassword ? true : false,
    errorMessage: errors.repeatNewPassword,
    testID: "repeatNewPassword",
    onChangeText: handleChange('repeatNewPassword'),
    onBlur: handleBlur('repeatNewPassword'),
    value: values.repeatNewPassword,
    disabled: isLocked,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 295,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React.createElement(InformationalScreen.Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 314,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    label: i18n.t('Global.microcopy.common.save'),
    disabled: !values.currentPassword || !values.newPassword || !values.repeatNewPassword || !isValid || isSubmitting || !meetsPasswordRequirements,
    onPress: () => handleSubmit(),
    testID: "ChangePassword.save-button",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 315,
      columnNumber: 13
    }
  })))));
};
export default connector(UpdatePassword);